
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 4.2.1
 * Query Engine version: 1e7af066ee9cb95cf3a403c78d9aab3e6b04f37a
 */
Prisma.prismaVersion = {
  client: "4.2.1",
  engine: "1e7af066ee9cb95cf3a403c78d9aab3e6b04f37a"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.AirdropOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  description: 'description',
  collectibleId: 'collectibleId',
  appId: 'appId'
});

exports.Prisma.AirdropScalarFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  numEntities: 'numEntities',
  collectibleId: 'collectibleId',
  state: 'state',
  appId: 'appId',
  attributes: 'attributes'
});

exports.Prisma.BlockchainTransactionOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  blockchainTxId: 'blockchainTxId',
  createdOrgAppId: 'createdOrgAppId',
  deployedSmartContractTypeId: 'deployedSmartContractTypeId',
  createdSetId: 'createdSetId',
  createdCollectibleId: 'createdCollectibleId',
  createdNiftoryWalletId: 'createdNiftoryWalletId',
  walletId: 'walletId',
  marketplaceListingId: 'marketplaceListingId'
});

exports.Prisma.BlockchainTransactionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  blockchain: 'blockchain',
  blockchainTxId: 'blockchainTxId',
  blockchainTxName: 'blockchainTxName',
  blockchainTxData: 'blockchainTxData',
  state: 'state',
  createdOrgAppId: 'createdOrgAppId',
  deployedSmartContractTypeId: 'deployedSmartContractTypeId',
  createdSetId: 'createdSetId',
  createdCollectibleId: 'createdCollectibleId',
  createdNiftoryWalletId: 'createdNiftoryWalletId',
  walletId: 'walletId',
  marketplaceListingId: 'marketplaceListingId'
});

exports.Prisma.BlockchainTransactionSchedulerOrderByRelevanceFieldEnum = makeEnum({
  id: 'id'
});

exports.Prisma.BlockchainTransactionSchedulerScalarFieldEnum = makeEnum({
  id: 'id',
  blockchain: 'blockchain',
  maxNumberOfSlots: 'maxNumberOfSlots',
  numberOfSlotsInUse: 'numberOfSlotsInUse',
  schedulerIsRunning: 'schedulerIsRunning'
});

exports.Prisma.BlockchainTransactionSchedulerSlotOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  currentQueueId: 'currentQueueId',
  currentQueueURL: 'currentQueueURL',
  blockchainTransactionSchedulerId: 'blockchainTransactionSchedulerId'
});

exports.Prisma.BlockchainTransactionSchedulerSlotScalarFieldEnum = makeEnum({
  id: 'id',
  slotNumber: 'slotNumber',
  inUse: 'inUse',
  currentQueueNumber: 'currentQueueNumber',
  currentQueueId: 'currentQueueId',
  currentQueueURL: 'currentQueueURL',
  blockchainTransactionSchedulerId: 'blockchainTransactionSchedulerId'
});

exports.Prisma.BlockchainTransactionsQueueOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  queueURL: 'queueURL',
  currentSlotId: 'currentSlotId'
});

exports.Prisma.BlockchainTransactionsQueueScalarFieldEnum = makeEnum({
  id: 'id',
  queueNumber: 'queueNumber',
  blockchain: 'blockchain',
  appId: 'appId',
  queueURL: 'queueURL',
  queueMessageCount: 'queueMessageCount',
  currentSlotId: 'currentSlotId',
  currentSlotNumber: 'currentSlotNumber',
  queueIndex: 'queueIndex'
});

exports.Prisma.CollectibleContentOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  posterId: 'posterId'
});

exports.Prisma.CollectibleContentScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  posterId: 'posterId',
  attributes: 'attributes'
});

exports.Prisma.CollectibleFileOrderByRelevanceFieldEnum = makeEnum({
  collectibleContentId: 'collectibleContentId',
  mediaId: 'mediaId',
  thumbnailId: 'thumbnailId'
});

exports.Prisma.CollectibleFileScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  collectibleContentId: 'collectibleContentId',
  mediaId: 'mediaId',
  thumbnailId: 'thumbnailId',
  attributes: 'attributes'
});

exports.Prisma.CollectibleListingOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  description: 'description',
  appId: 'appId',
  setId: 'setId'
});

exports.Prisma.CollectibleListingScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  price: 'price',
  state: 'state',
  dropType: 'dropType',
  appId: 'appId',
  setId: 'setId',
  metadata: 'metadata',
  attributes: 'attributes',
  mintingType: 'mintingType',
  mintingBatchSize: 'mintingBatchSize',
  mintingBatchThresholdPercentage: 'mintingBatchThresholdPercentage'
});

exports.Prisma.CollectibleOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  blockchainId: 'blockchainId',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  contentId: 'contentId',
  appId: 'appId',
  setId: 'setId',
  collectibleListingId: 'collectibleListingId',
  domainUrl: 'domainUrl',
  resourceTransactionId: 'resourceTransactionId',
  tagsArray: 'tagsArray'
});

exports.Prisma.CollectibleScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  blockchainId: 'blockchainId',
  title: 'title',
  subtitle: 'subtitle',
  description: 'description',
  state: 'state',
  userWorkflow: 'userWorkflow',
  rarity: 'rarity',
  numEntities: 'numEntities',
  numMinted: 'numMinted',
  numPendingMinting: 'numPendingMinting',
  contentId: 'contentId',
  price: 'price',
  appId: 'appId',
  setId: 'setId',
  metadata: 'metadata',
  collectibleListingId: 'collectibleListingId',
  domainUrl: 'domainUrl',
  attributes: 'attributes',
  resourceTransactionId: 'resourceTransactionId',
  tagsArray: 'tagsArray'
});

exports.Prisma.CustomTransactionOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  label: 'label',
  code: 'code',
  hash: 'hash',
  metadataScript: 'metadataScript',
  appId: 'appId'
});

exports.Prisma.CustomTransactionScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  label: 'label',
  code: 'code',
  hash: 'hash',
  metadataScript: 'metadataScript',
  state: 'state',
  appId: 'appId'
});

exports.Prisma.EntityOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  nftHash: 'nftHash',
  serialNumber: 'serialNumber',
  timerQueueMessageId: 'timerQueueMessageId',
  resourceTransactionId: 'resourceTransactionId',
  appId: 'appId',
  collectibleId: 'collectibleId',
  packId: 'packId',
  userId: 'userId',
  walletId: 'walletId'
});

exports.Prisma.EntityScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  nftHash: 'nftHash',
  serialNumber: 'serialNumber',
  hold: 'hold',
  saleProcessingState: 'saleProcessingState',
  blockchainState: 'blockchainState',
  timerQueueMessageId: 'timerQueueMessageId',
  attributes: 'attributes',
  resourceTransactionId: 'resourceTransactionId',
  appId: 'appId',
  collectibleId: 'collectibleId',
  packId: 'packId',
  userId: 'userId',
  walletId: 'walletId'
});

exports.Prisma.FileOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  key: 'key',
  md5: 'md5',
  contentType: 'contentType',
  url: 'url',
  name: 'name',
  ipfsUrl: 'ipfsUrl',
  ipfsContentUrl: 'ipfsContentUrl',
  ipfsMetadataUrl: 'ipfsMetadataUrl',
  appId: 'appId'
});

exports.Prisma.FileScalarFieldEnum = makeEnum({
  id: 'id',
  key: 'key',
  md5: 'md5',
  contentType: 'contentType',
  url: 'url',
  name: 'name',
  state: 'state',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipfsUrl: 'ipfsUrl',
  ipfsContentUrl: 'ipfsContentUrl',
  ipfsMetadataUrl: 'ipfsMetadataUrl',
  attributes: 'attributes',
  createFileOptions: 'createFileOptions',
  appId: 'appId'
});

exports.Prisma.InvoiceLineItemOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  entityId: 'entityId',
  packId: 'packId',
  invoiceId: 'invoiceId'
});

exports.Prisma.InvoiceLineItemScalarFieldEnum = makeEnum({
  id: 'id',
  price: 'price',
  tax: 'tax',
  entityId: 'entityId',
  packId: 'packId',
  invoiceId: 'invoiceId'
});

exports.Prisma.InvoiceOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  currency: 'currency',
  buyerUserId: 'buyerUserId',
  sellerAppId: 'sellerAppId',
  sellerUserId: 'sellerUserId',
  entityIds: 'entityIds',
  collectibleListingId: 'collectibleListingId',
  packListingId: 'packListingId',
  parentInvoiceId: 'parentInvoiceId',
  displayTitle: 'displayTitle',
  displayImage: 'displayImage'
});

exports.Prisma.InvoiceScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  invoiceType: 'invoiceType',
  invoiceState: 'invoiceState',
  total: 'total',
  currency: 'currency',
  buyerUserId: 'buyerUserId',
  sellerAppId: 'sellerAppId',
  sellerUserId: 'sellerUserId',
  entityIds: 'entityIds',
  collectibleListingId: 'collectibleListingId',
  packListingId: 'packListingId',
  parentInvoiceId: 'parentInvoiceId',
  displayTitle: 'displayTitle',
  displayImage: 'displayImage'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
});

exports.Prisma.KMSKeyOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  keyId: 'keyId',
  kmsKeyPoolId: 'kmsKeyPoolId'
});

exports.Prisma.KMSKeyPoolOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  keyPoolName: 'keyPoolName'
});

exports.Prisma.KMSKeyPoolScalarFieldEnum = makeEnum({
  id: 'id',
  keyPoolName: 'keyPoolName',
  keyPoolSize: 'keyPoolSize',
  kmsKeyProvider: 'kmsKeyProvider'
});

exports.Prisma.KMSKeyScalarFieldEnum = makeEnum({
  id: 'id',
  keyId: 'keyId',
  kmsKeyProvider: 'kmsKeyProvider',
  numTimesSelected: 'numTimesSelected',
  kmsKeyPoolId: 'kmsKeyPoolId'
});

exports.Prisma.MarketplaceListingOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  nftId: 'nftId',
  nftModelId: 'nftModelId',
  transactionIds: 'transactionIds',
  blockchainId: 'blockchainId',
  userId: 'userId',
  walletId: 'walletId',
  currency: 'currency'
});

exports.Prisma.MarketplaceListingScalarFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  nftId: 'nftId',
  nftModelId: 'nftModelId',
  state: 'state',
  transactionIds: 'transactionIds',
  blockchainId: 'blockchainId',
  userId: 'userId',
  walletId: 'walletId',
  currency: 'currency',
  price: 'price',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.NiftoryWalletOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  globalUserId: 'globalUserId',
  address: 'address',
  kmsKeyId: 'kmsKeyId'
});

exports.Prisma.NiftoryWalletScalarFieldEnum = makeEnum({
  id: 'id',
  globalUserId: 'globalUserId',
  address: 'address',
  kmsKeyProvider: 'kmsKeyProvider',
  kmsKeyId: 'kmsKeyId',
  state: 'state'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
});

exports.Prisma.OrgOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  name: 'name',
  smartContractTypeId: 'smartContractTypeId',
  logoId: 'logoId',
  storageAddress: 'storageAddress',
  storageAddressKMSKeyId: 'storageAddressKMSKeyId',
  organizationId: 'organizationId',
  creatorClientId: 'creatorClientId',
  dapperMerchantAddress: 'dapperMerchantAddress'
});

exports.Prisma.OrgScalarFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  blockchain: 'blockchain',
  smartContractTypeId: 'smartContractTypeId',
  logoId: 'logoId',
  attributes: 'attributes',
  storageAddress: 'storageAddress',
  storageAddressKMSKeyProvider: 'storageAddressKMSKeyProvider',
  storageAddressKMSKeyId: 'storageAddressKMSKeyId',
  blockchainTxVerticalConcurrency: 'blockchainTxVerticalConcurrency',
  niftoryWalletKeyPoolSize: 'niftoryWalletKeyPoolSize',
  organizationId: 'organizationId',
  creatorClientId: 'creatorClientId',
  dapperMerchantAddress: 'dapperMerchantAddress',
  dapperTransactionVersion: 'dapperTransactionVersion'
});

exports.Prisma.OrganizationOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  name: 'name'
});

exports.Prisma.OrganizationScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.PackListingOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  title: 'title',
  description: 'description',
  src: 'src',
  collectibleIds: 'collectibleIds',
  appId: 'appId',
  setId: 'setId',
  airdropId: 'airdropId'
});

exports.Prisma.PackListingScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  description: 'description',
  src: 'src',
  price: 'price',
  status: 'status',
  state: 'state',
  numPacks: 'numPacks',
  numItems: 'numItems',
  packShape: 'packShape',
  collectibleIds: 'collectibleIds',
  appId: 'appId',
  setId: 'setId',
  airdropId: 'airdropId',
  metadata: 'metadata',
  attributes: 'attributes'
});

exports.Prisma.PackOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  timerQueueMessageId: 'timerQueueMessageId',
  packListingId: 'packListingId',
  appId: 'appId',
  userId: 'userId'
});

exports.Prisma.PackScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  hold: 'hold',
  saleProcessingState: 'saleProcessingState',
  timerQueueMessageId: 'timerQueueMessageId',
  packListingId: 'packListingId',
  appId: 'appId',
  userId: 'userId',
  metadata: 'metadata',
  attributes: 'attributes'
});

exports.Prisma.PaymentOrderByRelevanceFieldEnum = makeEnum({
  currency: 'currency',
  paymentUniqueId: 'paymentUniqueId',
  invoiceId: 'invoiceId',
  clientSecret: 'clientSecret'
});

exports.Prisma.PaymentProviderOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  providerUniqueKey: 'providerUniqueKey',
  config: 'config',
  orgId: 'orgId',
  userId: 'userId'
});

exports.Prisma.PaymentProviderScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  id: 'id',
  providerUniqueKey: 'providerUniqueKey',
  providerType: 'providerType',
  config: 'config',
  orgId: 'orgId',
  userId: 'userId'
});

exports.Prisma.PaymentScalarFieldEnum = makeEnum({
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  total: 'total',
  currency: 'currency',
  paymentState: 'paymentState',
  paymentType: 'paymentType',
  paymentUniqueId: 'paymentUniqueId',
  providerType: 'providerType',
  invoiceId: 'invoiceId',
  clientSecret: 'clientSecret'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.RoleByOrganizationOrderByRelevanceFieldEnum = makeEnum({
  organizationId: 'organizationId',
  userId: 'userId'
});

exports.Prisma.RoleByOrganizationScalarFieldEnum = makeEnum({
  role: 'role',
  organizationId: 'organizationId',
  userId: 'userId'
});

exports.Prisma.SeriesOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  title: 'title'
});

exports.Prisma.SeriesScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  title: 'title',
  metadata: 'metadata',
  attributes: 'attributes'
});

exports.Prisma.SetOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  blockchainId: 'blockchainId',
  title: 'title',
  src: 'src',
  tagsArray: 'tagsArray',
  appId: 'appId',
  seriesId: 'seriesId',
  resourceTransactionId: 'resourceTransactionId'
});

exports.Prisma.SetScalarFieldEnum = makeEnum({
  id: 'id',
  blockchainId: 'blockchainId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  title: 'title',
  src: 'src',
  attributes: 'attributes',
  tagsArray: 'tagsArray',
  appId: 'appId',
  seriesId: 'seriesId',
  metadata: 'metadata',
  state: 'state',
  resourceTransactionId: 'resourceTransactionId'
});

exports.Prisma.SmartContractTypeOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  activeSeriesId: 'activeSeriesId',
  contractAddress: 'contractAddress',
  contractAddressKMSKeyId: 'contractAddressKMSKeyId'
});

exports.Prisma.SmartContractTypeScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  activeSeriesId: 'activeSeriesId',
  contractAddress: 'contractAddress',
  contractAddressKMSKeyProvider: 'contractAddressKMSKeyProvider',
  contractAddressKMSKeyId: 'contractAddressKMSKeyId',
  blockchain: 'blockchain',
  contractVersion: 'contractVersion',
  contractMetadata: 'contractMetadata',
  state: 'state'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.TagOrderByRelevanceFieldEnum = makeEnum({
  name: 'name',
  description: 'description'
});

exports.Prisma.TagScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  description: 'description'
});

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.TransactionsQueuePoolEntryOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  queueURL: 'queueURL',
  queuePoolId: 'queuePoolId'
});

exports.Prisma.TransactionsQueuePoolEntryScalarFieldEnum = makeEnum({
  id: 'id',
  queueURL: 'queueURL',
  numTimesSelected: 'numTimesSelected',
  queuePoolId: 'queuePoolId'
});

exports.Prisma.TransactionsQueuePoolOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  queuePoolName: 'queuePoolName'
});

exports.Prisma.TransactionsQueuePoolScalarFieldEnum = makeEnum({
  id: 'id',
  queuePoolName: 'queuePoolName',
  queuePoolSize: 'queuePoolSize'
});

exports.Prisma.UserOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  name: 'name',
  email: 'email',
  image: 'image',
  avatarUrl: 'avatarUrl',
  globalUserId: 'globalUserId',
  primaryWalletId: 'primaryWalletId'
});

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  email: 'email',
  emailVerified: 'emailVerified',
  image: 'image',
  role: 'role',
  avatarUrl: 'avatarUrl',
  tosAcceptanceDateTime: 'tosAcceptanceDateTime',
  globalUserId: 'globalUserId',
  primaryWalletId: 'primaryWalletId',
  attributes: 'attributes'
});

exports.Prisma.WalletOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  address: 'address',
  cid: 'cid',
  verificationCode: 'verificationCode',
  userId: 'userId',
  niftoryWalletId: 'niftoryWalletId'
});

exports.Prisma.WalletScalarFieldEnum = makeEnum({
  id: 'id',
  appId: 'appId',
  address: 'address',
  cid: 'cid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  verificationCode: 'verificationCode',
  verificationCodeCreationTime: 'verificationCodeCreationTime',
  userId: 'userId',
  blob: 'blob',
  attributes: 'attributes',
  niftoryWalletId: 'niftoryWalletId'
});

exports.Prisma.WorkflowOrderByRelevanceFieldEnum = makeEnum({
  id: 'id',
  type: 'type',
  prevWorkflowId: 'prevWorkflowId'
});

exports.Prisma.WorkflowScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  type: 'type',
  input: 'input',
  result: 'result',
  prevWorkflowId: 'prevWorkflowId',
  numActiveWorkflows: 'numActiveWorkflows'
});
exports.AirdropState = makeEnum({
  DRAFT: 'DRAFT',
  SENT: 'SENT'
});

exports.Blockchain = makeEnum({
  Flow: 'Flow',
  Polygon: 'Polygon',
  Ethereum: 'Ethereum'
});

exports.BlockchainTransactionName = makeEnum({
  BL_CREATE_SET_TX: 'BL_CREATE_SET_TX',
  BL_REPLACE_SET_METADATA_TX: 'BL_REPLACE_SET_METADATA_TX',
  BL_CREATE_COLLECTIBLE_ITEM_TX: 'BL_CREATE_COLLECTIBLE_ITEM_TX',
  BL_REPLACE_COLLECTIBLE_ITEM_METADATA_TX: 'BL_REPLACE_COLLECTIBLE_ITEM_METADATA_TX',
  BL_SET_COLLECTIBLE_ITEM_MAX_MINT_TX: 'BL_SET_COLLECTIBLE_ITEM_MAX_MINT_TX',
  BL_MINT_NFTS_TX: 'BL_MINT_NFTS_TX',
  BL_MINT_ALL_NFTS_IN_SET_TX: 'BL_MINT_ALL_NFTS_IN_SET_TX',
  BL_MINT_NFTS_FROM_COLLECTIBLE_LISTING_TX: 'BL_MINT_NFTS_FROM_COLLECTIBLE_LISTING_TX',
  BL_TRANSFER_NFTS_TX: 'BL_TRANSFER_NFTS_TX',
  BL_WITHDRAW_NFTS_FROM_CUSTODIAL_WALLET_TX: 'BL_WITHDRAW_NFTS_FROM_CUSTODIAL_WALLET_TX',
  BL_AIRDROP_NFTS_TX: 'BL_AIRDROP_NFTS_TX',
  BL_CREATE_AND_INITIALIZE_NIFTORY_WALLET_TX: 'BL_CREATE_AND_INITIALIZE_NIFTORY_WALLET_TX',
  BL_SETUP_ACCOUNT_TX: 'BL_SETUP_ACCOUNT_TX',
  BL_DEPLOY_CONTRACT_TX: 'BL_DEPLOY_CONTRACT_TX',
  BL_CREATE_AND_INITIALIZE_CONTRACT_TX: 'BL_CREATE_AND_INITIALIZE_CONTRACT_TX',
  BL_CREATE_ACCOUNT_TX: 'BL_CREATE_ACCOUNT_TX',
  BL_UPDATE_CONTRACT_TX: 'BL_UPDATE_CONTRACT_TX',
  BL_SET_ACCOUNT_KEY_INDICES_TX: 'BL_SET_ACCOUNT_KEY_INDICES_TX',
  BL_SET_CONTRACT_COLLECTION_METADATA_TX: 'BL_SET_CONTRACT_COLLECTION_METADATA_TX',
  BL_REGISTER_TO_CATALOG_TX: 'BL_REGISTER_TO_CATALOG_TX',
  BL_TRANSFER_OWNERSHIP_TX: 'BL_TRANSFER_OWNERSHIP_TX',
  BL_SET_CONTRACT_URI_TX: 'BL_SET_CONTRACT_URI_TX',
  BL_SETUP_NFT_STOREFRONT_ACCOUNT_TX: 'BL_SETUP_NFT_STOREFRONT_ACCOUNT_TX',
  BL_SELL_NFT_STOREFRONT_ITEM_TX: 'BL_SELL_NFT_STOREFRONT_ITEM_TX',
  BL_REMOVE_NFT_STOREFRONT_ITEM_TX: 'BL_REMOVE_NFT_STOREFRONT_ITEM_TX',
  BL_RETIRE_COLLECTIBLE_ITEM_TX: 'BL_RETIRE_COLLECTIBLE_ITEM_TX',
  BL_RETIRE_ALL_COLLECTIBLE_ITEMS_IN_SET_TX: 'BL_RETIRE_ALL_COLLECTIBLE_ITEMS_IN_SET_TX',
  BL_START_NEW_SERIES_TX: 'BL_START_NEW_SERIES_TX',
  BL_TRANSFER_FLOW_TOKENS_TX: 'BL_TRANSFER_FLOW_TOKENS_TX',
  BL_CUSTOM_NIFTORY_WALLET_TX: 'BL_CUSTOM_NIFTORY_WALLET_TX',
  BL_WAIT_FOR_TRANSACTION_COMPLETION_TX: 'BL_WAIT_FOR_TRANSACTION_COMPLETION_TX'
});

exports.BlockchainTransactionState = makeEnum({
  PENDING: 'PENDING',
  SEALED: 'SEALED'
});

exports.CollectibleBlockchainState = makeEnum({
  UNMINTED: 'UNMINTED',
  MINTING: 'MINTING',
  MINTED: 'MINTED',
  ERROR: 'ERROR',
  COMPLETED: 'COMPLETED'
});

exports.CollectibleListingState = makeEnum({
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
});

exports.ContractState = makeEnum({
  CREATED: 'CREATED',
  DEPLOYING: 'DEPLOYING',
  DEPLOY_FAILED: 'DEPLOY_FAILED',
  READY: 'READY',
  UPDATING: 'UPDATING',
  UPDATE_FAILED: 'UPDATE_FAILED'
});

exports.ContractVersion = makeEnum({
  V1: 'V1',
  V2: 'V2',
  V2_1: 'V2_1',
  V2_1_1: 'V2_1_1',
  V2_2: 'V2_2'
});

exports.CustomTransactionState = makeEnum({
  SUBMITTED: 'SUBMITTED',
  ALLOWED: 'ALLOWED'
});

exports.DapperTransactionVersion = makeEnum({
  v1: 'v1',
  v2: 'v2'
});

exports.EntityBlockchainState = makeEnum({
  UNMINTED: 'UNMINTED',
  MINTING: 'MINTING',
  TRANSFERRING: 'TRANSFERRING',
  MINTED: 'MINTED',
  ERROR: 'ERROR',
  TRANSFERRED: 'TRANSFERRED'
});

exports.FileState = makeEnum({
  PENDING: 'PENDING',
  GENERATED_UPLOAD_URL: 'GENERATED_UPLOAD_URL',
  UPLOADED_TO_CLOUD_STORAGE: 'UPLOADED_TO_CLOUD_STORAGE',
  UPLOADED_TO_IPFS: 'UPLOADED_TO_IPFS',
  READY: 'READY',
  ERROR: 'ERROR'
});

exports.InvoiceState = makeEnum({
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
  TRANSFERING_TO_COMPLETE: 'TRANSFERING_TO_COMPLETE'
});

exports.InvoiceType = makeEnum({
  PURCHASE: 'PURCHASE',
  REFUND: 'REFUND',
  CHARGEBACK: 'CHARGEBACK'
});

exports.KMSKeyProviderType = makeEnum({
  AWS_KMS_KEY_PROVIDER: 'AWS_KMS_KEY_PROVIDER',
  GCP_KMS_KEY_PROVIDER: 'GCP_KMS_KEY_PROVIDER'
});

exports.ListingDropType = makeEnum({
  SINGLE_DROP_LISTING: 'SINGLE_DROP_LISTING',
  BULK_DROPS_LISTING: 'BULK_DROPS_LISTING',
  GENERATIVE_DROPS_LISTING: 'GENERATIVE_DROPS_LISTING'
});

exports.MarketplaceListingState = makeEnum({
  AVAILABLE: 'AVAILABLE',
  PURCHASED: 'PURCHASED',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED'
});

exports.MintingType = makeEnum({
  MANUAL_MINTING: 'MANUAL_MINTING',
  BATCH_MINTING: 'BATCH_MINTING',
  LAZY_MINTING: 'LAZY_MINTING'
});

exports.NiftoryWalletState = makeEnum({
  PENDING_CREATION: 'PENDING_CREATION',
  PENDING_CUSTOMER_VERIFICATION: 'PENDING_CUSTOMER_VERIFICATION',
  CREATED: 'CREATED',
  CREATION_FAILED: 'CREATION_FAILED'
});

exports.OrganizationRole = makeEnum({
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
});

exports.PackListingState = makeEnum({
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
});

exports.PackState = makeEnum({
  EMPTY: 'EMPTY',
  FILLING: 'FILLING',
  FILLED: 'FILLED',
  MINTED: 'MINTED',
  ONSALE: 'ONSALE',
  SOLD: 'SOLD',
  CLOSED: 'CLOSED',
  OPENED: 'OPENED'
});

exports.PaymentProviderType = makeEnum({
  TEST: 'TEST',
  STRIPE: 'STRIPE',
  CRYPTOCOM: 'CRYPTOCOM',
  COINBASE: 'COINBASE',
  COINPAYMENTS: 'COINPAYMENTS',
  BITPAY: 'BITPAY'
});

exports.PaymentState = makeEnum({
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ERROR_FAILED_TO_GRANT: 'ERROR_FAILED_TO_GRANT',
  CANCELED: 'CANCELED',
  ERROR: 'ERROR'
});

exports.PaymentType = makeEnum({
  PURCHASE: 'PURCHASE',
  REFUND: 'REFUND',
  CHARGEBACK: 'CHARGEBACK'
});

exports.Rarity = makeEnum({
  COMMON: 'COMMON',
  RARE: 'RARE',
  LEGENDARY: 'LEGENDARY'
});

exports.Role = makeEnum({
  INVITED: 'INVITED',
  COLLECTOR: 'COLLECTOR',
  MARKETER: 'MARKETER',
  CREATOR: 'CREATOR',
  MANAGER: 'MANAGER',
  MINTER: 'MINTER',
  ADMIN: 'ADMIN'
});

exports.SaleProcessingState = makeEnum({
  AVAILABLE: 'AVAILABLE',
  RESERVED: 'RESERVED',
  HOLD: 'HOLD',
  SOLD: 'SOLD'
});

exports.SeriesState = makeEnum({
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED'
});

exports.SetBlockchainState = makeEnum({
  UNMINTED: 'UNMINTED',
  MINTING: 'MINTING',
  MINTED: 'MINTED',
  ERROR: 'ERROR'
});

exports.UserWorkflow = makeEnum({
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  TO_DO: 'TO_DO',
  DONE: 'DONE'
});

exports.WalletState = makeEnum({
  PENDING_CREATION: 'PENDING_CREATION',
  UNVERIFIED: 'UNVERIFIED',
  VERIFIED: 'VERIFIED',
  READY: 'READY',
  CREATION_FAILED: 'CREATION_FAILED'
});

exports.WorkflowState = makeEnum({
  CREATED: 'CREATED',
  SCHEDULED: 'SCHEDULED',
  RUNNING: 'RUNNING',
  JOB_COMPLETED_SCHEDULED_NEXT: 'JOB_COMPLETED_SCHEDULED_NEXT',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Organization: 'Organization',
  Org: 'Org',
  RoleByOrganization: 'RoleByOrganization',
  SmartContractType: 'SmartContractType',
  Set: 'Set',
  Collectible: 'Collectible',
  CollectibleContent: 'CollectibleContent',
  Entity: 'Entity',
  Tag: 'Tag',
  Wallet: 'Wallet',
  NiftoryWallet: 'NiftoryWallet',
  CollectibleFile: 'CollectibleFile',
  File: 'File',
  MarketplaceListing: 'MarketplaceListing',
  KMSKeyPool: 'KMSKeyPool',
  KMSKey: 'KMSKey',
  TransactionsQueuePool: 'TransactionsQueuePool',
  TransactionsQueuePoolEntry: 'TransactionsQueuePoolEntry',
  BlockchainTransactionsQueue: 'BlockchainTransactionsQueue',
  BlockchainTransactionScheduler: 'BlockchainTransactionScheduler',
  BlockchainTransactionSchedulerSlot: 'BlockchainTransactionSchedulerSlot',
  BlockchainTransaction: 'BlockchainTransaction',
  CustomTransaction: 'CustomTransaction',
  CollectibleListing: 'CollectibleListing',
  Airdrop: 'Airdrop',
  PaymentProvider: 'PaymentProvider',
  Payment: 'Payment',
  Invoice: 'Invoice',
  InvoiceLineItem: 'InvoiceLineItem',
  Workflow: 'Workflow',
  Series: 'Series',
  PackListing: 'PackListing',
  Pack: 'Pack'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
